<template>
    <ValidationObserver v-slot="{handleSubmit}" ref="formRef">
        <form @submit.prevent="handleSubmit(submitForm)" :id="formId">
            <ValidationProvider vid="role" :name="$t('users.edit_role')" rules="required" v-slot="{ errors }">
                <div class="form-group row">
                    <label class="form-control-label col-4">{{ $t('users.edit_role') }}*</label>
                    <div class="col-8">
                        <div v-for="role in availableRoles" :key="role">
                            <div class="custom-control custom-radio">
                                <input
                                    type="radio"
                                    :id="role"
                                    class="custom-control-input"
                                    :value="role"
                                    :disabled="isLoading"
                                    v-model="formValues.role"
                                />

                                <label class="custom-control-label" :for="role" v-tooltip="$t('roles.' + role + '_description')">
                                    {{ $t('roles.' + role) }}

                                    <sup><strong>?</strong></sup>
                                </label>
                            </div>
                        </div>

                        <div class="invalid-feedback d-block" v-if="errors.length">
                            {{ errors[0] }}
                        </div>
                    </div>
                </div>
            </ValidationProvider>
        </form>
    </ValidationObserver>
</template>

<script setup>

    import { computed, inject, ref, watch } from 'vue';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { Roles } from '../../enums/roles';

    const emit = defineEmits(['submit']);

    const store = inject('store');
    const props = defineProps({
        user: {
            type: Object,
            required: true,
        },

        isLoading: {
            type: Boolean,
            default: false,
        },

        formId: {
            type: String,
            default: null,
        },

        errors: {
            type: Object,
            default: null,
        },
    });

    const availableRoles = computed(() => {
        return [
            Roles.Staff,
            Roles.MusicManager,
            Roles.GeneralManager
        ];
    });

    const formValues = ref({
        role: props.user.roles?.[0]?.name || Roles.Staff,
    });
    const formRef = ref(null);

    watch(() => props.errors, () => {
        formRef.value.setErrors(props.errors);
    });

    function submitForm() {
        emit('submit', formValues.value);
    }
</script>
